module.exports = __webpack_public_path__ + "img/10.4c73033a.png";